import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ThemeProvider } from '../hooks/useTheme';
import DesktopNavigation from './DesktopNavigation';
import MobileNavigation from './MobileNavigation';
import '../styles/globals.css';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <ThemeProvider>
      <div className="app-shell">
        {/* Desktop Navigation */}
        {!isMobile && <DesktopNavigation />}
        
        {/* Main Content */}
        <main className={`app-main ${isMobile ? 'mobile-nav-spacing' : ''}`}>
          {children}
        </main>
        
        {/* Mobile Navigation */}
        {isMobile && <MobileNavigation />}
      </div>
    </ThemeProvider>
  );
};

export default Layout;


